import { Dropdown } from 'antd';
import type { ItemType } from 'antd/es/menu/interface';

import { RoleEnum } from '@enum/role.enum';
import { useMemberRole } from '@hook/memeber/use-member-role.hook';
import { useStoreSelector } from '@hook/store/store.hooks';
import { MemberInterface } from '@interface/member/member.interface';

import { AccountMemberActionsEnum } from './account-member-actions.enum';
import { useAccountMemberActions } from './account-member-actions.hook';
import { Dots } from './account-member-actions.style';

interface AccountMemberActionsProps {
  member: MemberInterface;
}

export const AccountMemberActions = ({ member }: AccountMemberActionsProps) => {
  const user = useStoreSelector((state) => state.user.data);
  const handleClick = useAccountMemberActions(member);
  const { isAdmin, isOwner } = useMemberRole();

  if (user.email === member.email || !(isAdmin || isOwner)) return null;

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          member.role !== RoleEnum.Admin && {
            key: AccountMemberActionsEnum.RoleA,
            label: 'Change to admin',
          },
          member.role !== RoleEnum.Developer && {
            key: AccountMemberActionsEnum.RoleD,
            label: 'Change to developer',
          },
          member.role !== RoleEnum.User && {
            key: AccountMemberActionsEnum.RoleV,
            label: 'Change to viewer',
          },
          {
            key: AccountMemberActionsEnum.Suspend,
            label: member.isSuspended ? 'Unsuspend' : 'Suspend',
          },
          {
            key: AccountMemberActionsEnum.Delete,
            danger: true,
            label: 'Delete Member',
          },
        ].filter(Boolean) as ItemType[],
        onClick: handleClick as any,
      }}
    >
      <Dots />
    </Dropdown>
  );
};
